export default __webpack_public_path__ + "static/media/NetatmoAlert.c428cd33.svg";